// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5b2f3a08","455":"4216bb42"}[chunkId] + ".chunk.js";
};